import { put } from "../../utils/api";
import GenericViewDrawer1 from "./GenericViewDrawer1";

const renderList = (data, key = "name") => {
  if (!data) return "—";
  if (Array.isArray(data)) {
    return data.length > 0
      ? data
          .map((item) =>
            typeof item === "object" ? item?.[key] || `ID: ${item._id}` : item
          )
          .join(", ")
      : "—";
  } else if (typeof data === "object") {
    return data?.[key] || `ID: ${data._id}`;
  }

  return "—";
};
const ViewDetailsDrawerFacility = ({
  open,
  onClose,
  data,
  setsnackOpen,
  fetchDataCallback,
  apiUrl,
}) => {
  if (!data) return null;

  const handleApprovalAction = async (action) => {
    try {
      const response = await put(`${apiUrl}/${data._id}`, {
        approvalStatus: action === "approve" ? "Accepted" : "Rejected",
      });
      if (response?.data) {
        setsnackOpen({
          open: true,
          message: response.data.message,
          severity: "success",
        });
        fetchDataCallback();
        onClose();
      }
    } catch (error) {
      setsnackOpen({
        open: true,
        message: error.message || "An error occurred",
        severity: "error",
      });
    }
  };

  const fields = [
    {
      label: "Consumption Month",
      previous: `${data?.consumptionPeriod?.month}/${data?.consumptionPeriod?.year}`,
      requested: `${data?.editValue?.consumptionPeriod?.month || "—"}/${
        data?.editValue?.consumptionPeriod?.year || "—"
      }`,
    },
    {
      label: "Previous Meter Reading",
      previous: data?.previousMeterReading,
      requested: data?.editValue?.previousMeterReading,
    },
    {
      label: "Current Meter Reading",
      previous: data?.currentMeterReading,
      requested: data?.editValue?.currentMeterReading,
    },
    {
      label: "Unit of Electricity Consumption",
      previous: data?.unitConsumption || data?.unitOfConsumption,
      requested:
        data?.editValue?.unitConsumption || data?.editValue?.unitOfConsumption,
    },
    {
      label: "Multiplication Factor",
      previous: data?.multiplicationFactor,
      requested: data?.editValue?.multiplicationFactor,
    },
    {
      label: "Equipment",
      previous: renderList(data?.equipment, "equipment"),
      requested: renderList(data?.editValue?.equipmentData, "equipment"),
    },
    {
      label: "Vendor",
      previous: data?.vendor?.VendorLegalFullName,
      requested: data?.editValue?.vendorData?.VendorLegalFullName,
    },
    {
      label: "Reason for Deviation",
      previous: data?.reasonForDeviation,
      requested: data?.editValue?.reasonForDeviation,
    },
    {
      label: "Remarks",
      previous: data?.remarks,
      requested: data?.editValue?.remarks,
    },
  ];

  return (
    <GenericViewDrawer1
      open={open}
      onClose={onClose}
      title="Faility Equipment Consumption Details"
      fields={fields}
      documentsField={{
        label: "Documents",
        previous: data?.documents,
        requested: data?.editValue?.documents,
      }}
      timeline={data?.timeLine}
      editRemarkReason={data?.editRemarkReason}
      onApprove={() => handleApprovalAction("approve")}
      onReject={() => handleApprovalAction("reject")}
    />
  );
};

export default ViewDetailsDrawerFacility;
